export class ChatObservable {
  constructor() {
    this.observers = [];
  }

  static create() {
    return new ChatObservable();
  }

  subscribe(observer) {
    if (typeof observer !== "function") {
      throw Error("Observer must be a function");
    }

    this.observers.push(observer);
  }

  unsubscribe(observer) {
    if (typeof observer !== "function") {
      throw Error("Observer must be a function");
    }

    const observerIndex = this.observers.indexOf(observer);
    if (observerIndex >= 0) {
      this.observers.splice(observerIndex, 1);
    }
  }

  notify(message) {
    this.observers.forEach((observer) => {
      observer(message);
    });
  }
}
